<template>
    <Overlay :show="isSaving">
        <ConcernElements
            :product="context.product"
            :legislations="legislationIds"
            :included-substances="context.includedSubstances || []"
            :excluded-substances="context.excludedSubstances || []"
            :show-questions="settings.showQuestions"
            :show-instruction="settings.showInstruction"
            :show-substance-list-instruction="settings.showSubstanceListInstruction"
            :show-no-single-parts-checkbox="settings.showNoSinglePartsCheckbox"
            :show-information-owner-settings="settings.showInformationOwnerSettings"
            :company-has-information="settings.companyHasInformation"
            :auto-expand-lists="autoExpandLists"
            :auto-expand-substances="autoExpandSubstances"
            :auto-expand-list-when-only-one="settings.autoExpandListWhenOnlyOne"
            :reference-title-mode="settings.referenceTitleMode"
            container-class=""
            @include="handleInclude"
            @exclude="handleExclude"
            @undefined="handleUndefined"
            @listQuestionStateUpdated="handleListQuestionStateUpdated"
            @informationOwnerSettingsChanged="handleInformationOwnerSettingsChanged"
        />
    </Overlay>
</template>

<script>
import { ConcernElements } from '@/views/product/components/product-card'
import Overlay from '@core/components/common/Overlay.vue'

const isSingleLegislation = (mode, legislationIds) => (
    mode === 'single-legislation' && legislationIds.length === 1
)

export default {
    name: 'ConcernSubstanceListsStep',
    components: {
        ConcernElements,
        Overlay,
    },
    props: {
        context: {
            type: Object,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        runtimeState: {
            type: Object,
            required: true,
        },
    },
    computed: {
        legislationIds() {
            const legislations = this.context.request && Array.isArray(this.context.request.legislations)
                ? this.context.request.legislations
                : []

            return legislations.map(legislation => legislation.id)
        },
        autoExpandLists() {
            return this.settings.autoExpandListsMode === 'always'
                || isSingleLegislation(this.settings.autoExpandListsMode, this.legislationIds)
        },
        autoExpandSubstances() {
            return this.settings.autoExpandSubstancesMode === 'always'
                || isSingleLegislation(this.settings.autoExpandSubstancesMode, this.legislationIds)
        },
        isSaving() {
            return this.runtimeState.isLoading || this.runtimeState.isSaving
        },
    },
    mounted() {
        this.$emit('validity-change', {
            isValid: true,
            errors: [],
        })
    },
    methods: {
        handleInclude(substance, emittedListIds = []) {
            this.$emit('action', {
                type: 'substance.include',
                payload: { substance, emittedListIds },
            })
        },
        handleExclude(substance) {
            this.$emit('action', {
                type: 'substance.exclude',
                payload: { substance },
            })
        },
        handleUndefined(substance) {
            this.$emit('action', {
                type: 'substance.undefined',
                payload: { substance },
            })
        },
        handleListQuestionStateUpdated(list, state) {
            this.$emit('action', {
                type: 'list-question.update',
                payload: { list, state },
            })
        },
        handleInformationOwnerSettingsChanged(settings) {
            this.$emit('action', {
                type: 'information-owner-settings.update',
                payload: { settings },
            })
        },
    },
}
</script>
